// extracted by mini-css-extract-plugin
export default {"piBtn":"Button_piBtn__HLr+H"};